class DataGridFiltersCacheService {
    private static readonly FILTER_KEY_PREFIX = 'datagrid_filter';
    private static readonly SORT_KEY_PREFIX = 'datagrid_sort';

    // ==================== ФИЛЬТРЫ ====================

    private static getFilterKey(entityType: string, columnId: string): string {
        return `${this.FILTER_KEY_PREFIX}:${entityType}:${columnId}`;
    }

    static getFilter(entityType: string, columnId: string): unknown {
        try {
            const key = this.getFilterKey(entityType, columnId);
            const stored = localStorage.getItem(key);

            if (!stored) return null;

            return JSON.parse(stored);
        } catch (e) {
            console.error('DataGridFiltersCacheService.getFilter error:', e);
            return null;
        }
    }

    static setFilter(entityType: string, columnId: string, value: unknown): void {
        try {
            const key = this.getFilterKey(entityType, columnId);

            if (value == null || value === '' || (Array.isArray(value) && value.length === 0)) {
                localStorage.removeItem(key);
                return;
            }

            localStorage.setItem(key, JSON.stringify(value));
        } catch (e) {
            console.error('DataGridFiltersCacheService.setFilter error:', e);
        }
    }

    static clearFilter(entityType: string, columnId: string): void {
        try {
            const key = this.getFilterKey(entityType, columnId);
            localStorage.removeItem(key);
        } catch (e) {
            console.error('DataGridFiltersCacheService.clearFilter error:', e);
        }
    }

    // ==================== СОРТИРОВКА ====================

    private static getSortKey(entityType: string): string {
        return `${this.SORT_KEY_PREFIX}:${entityType}`;
    }

    static getSort(entityType: string): { by: string; direction: 'asc' | 'desc' } | null {
        try {
            const key = this.getSortKey(entityType);
            const stored = localStorage.getItem(key);

            if (!stored) return null;

            return JSON.parse(stored);
        } catch (e) {
            console.error('DataGridFiltersCacheService.getSort error:', e);
            return null;
        }
    }

    static setSort(entityType: string, by: string | null, direction: 'asc' | 'desc' | null): void {
        try {
            const key = this.getSortKey(entityType);

            if (!by || !direction) {
                localStorage.removeItem(key);
                return;
            }

            localStorage.setItem(key, JSON.stringify({ by, direction }));
        } catch (e) {
            console.error('DataGridFiltersCacheService.setSort error:', e);
        }
    }

    static clearSort(entityType: string): void {
        try {
            const key = this.getSortKey(entityType);
            localStorage.removeItem(key);
        } catch (e) {
            console.error('DataGridFiltersCacheService.clearSort error:', e);
        }
    }

    // ==================== МАССОВАЯ ОЧИСТКА ====================

    static clearEntity(entityType: string): void {
        try {
            const filterPrefix = `${this.FILTER_KEY_PREFIX}:${entityType}:`;
            const sortKey = this.getSortKey(entityType);

            for (let i = localStorage.length - 1; i >= 0; i--) {
                const key = localStorage.key(i);
                if (key?.startsWith(filterPrefix) || key === sortKey) {
                    localStorage.removeItem(key);
                }
            }
        } catch (e) {
            console.error('DataGridFiltersCacheService.clearEntity error:', e);
        }
    }

    static clearAll(): void {
        try {
            for (let i = localStorage.length - 1; i >= 0; i--) {
                const key = localStorage.key(i);
                if (key?.startsWith(this.FILTER_KEY_PREFIX) || key?.startsWith(this.SORT_KEY_PREFIX)) {
                    localStorage.removeItem(key);
                }
            }
        } catch (e) {
            console.error('DataGridFiltersCacheService.clearAll error:', e);
        }
    }
}

export default DataGridFiltersCacheService;
